<app-navbar></app-navbar>
<div class="container">
  <div class="information">
    <div class="back-button">
      <a class="d-flex g-2" (click)="goBack()">
        <img src="../../../assets/img/svg/icons/left-arrow.svg" />
        <span>{{ "information.back" | translate }}</span>
      </a>
    </div>

    <div class="content g-3">
      <div class="d-flex align-items-center justify-content-center mb-4">
        <h2 class="m-0">{{ "information.title" | translate }}</h2>
      </div>

      <div class="table">
        <div class="element">
          <div class="element-title">
            {{ "information.appVersion" | translate }}
          </div>

          <div class="element-desc">
            {{ version }}
          </div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.manufacturer" | translate }}
          </div>

          <div class="element-desc">
            {{ "information.manufacturerDesc" | translate }}
          </div>
        </div>

        <div class="element">
          <div class="element-title">{{ "information.udiPi" | translate }}</div>

          <div class="element-desc">
            {{ "information.udiPiDesc" | translate }}
          </div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.targetPopulation" | translate }}
          </div>

          <div class="element-desc">
            {{ "information.targetPopulationDesc" | translate }}
          </div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.CeMarking" | translate }}
          </div>

          <div
            class="element-desc"
            [innerHTML]="'information.CeMarkingDesc' | translate"
          ></div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.ifu" | translate }}
          </div>

          <div
            class="element-desc"
            [innerHTML]="'information.ifuDesc' | translate"
          ></div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.intendedPurpose" | translate }}
          </div>

          <div class="element-desc">
            {{ "information.intendedPurposeDesc" | translate }}
          </div>
        </div>

        <div class="element">
          <div class="element-title">
            {{ "information.releaseDate" | translate }}
          </div>

          <div class="element-desc">{{ releaseDate }}</div>
        </div>
      </div>

      <span class="footer-info" style="display: flex; justify-content: center;">© 2025 Breathment GmbH.</span>
    </div>
  </div>
</div>
